import axios from "axios";

// Separate axios instance — no interceptors, so refresh calls never loop back into the 401 handler
const authAxios = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
});

const ACCESS_TOKEN_KEY = "proxy_access_token";
const REFRESH_TOKEN_KEY = "proxy_refresh_token";

export const tokenStorage = {
  getAccessToken() {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  },
  getRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  },
  setTokens(accessToken, refreshToken) {
    if (accessToken) localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    if (refreshToken) localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  },
  clearTokens() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  },
};

export const authTokenService = {
  /**
   * Step 1 — get a single-use nonce for the given Zetrix address.
   * GET /token/nonce?address={address}
   * Response: { nonce: string, ttlSeconds: number }
   */
  getNonce(address) {
    return authAxios.get("/token/nonce", { params: { address } });
  },

  /**
   * Step 3 — exchange signed nonce for access + refresh tokens.
   * POST /token  { address, publicKey, message: nonce, signData }
   * Response: { token, refreshToken, address, expiresIn, refreshExpiresIn }
   */
  createToken(address, publicKey, message, signData) {
    return authAxios.post("/token", { address, publicKey, message, signData });
  },

  /**
   * Refresh an expired access token using the stored refresh token.
   * POST /token/refresh  { refreshToken }
   * Response: { token, address, expiresIn }
   */
  refreshAccessToken(refreshToken) {
    return authAxios.post("/token/refresh", { refreshToken });
  },
};
